export default "/static/coldplate_tiny.png";